import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { Mail } from "lucide-react";

const NewsletterWidget = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      toast.error("Por favor ingresa tu email");
      return;
    }

    setLoading(true);

    try {
      const { error } = await supabase.functions.invoke("newsletter-subscribe", {
        body: { email, source: "widget" },
      });

      if (error) throw error;

      toast.success("¡Suscripción exitosa! 🎉");
      setEmail("");
    } catch (error: any) {
      console.error("Error:", error);
      toast.error("Error al suscribirse");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-card border rounded-lg p-6 space-y-4">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Mail className="h-5 w-5 text-primary" />
        </div>
        <div>
          <h3 className="font-semibold">Newsletter</h3>
          <p className="text-sm text-muted-foreground">
            Recibe tips de fitness y ofertas exclusivas
          </p>
        </div>
      </div>
      
      <form onSubmit={handleSubmit} className="flex gap-2">
        <Input
          type="email"
          placeholder="tu@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
          className="flex-1"
        />
        <Button type="submit" disabled={loading}>
          {loading ? "..." : "Suscribir"}
        </Button>
      </form>
    </div>
  );
};

export default NewsletterWidget;
